// extracted by mini-css-extract-plugin
module.exports = {"profile":"styles-module__profile___3Jddh"};